import { useRequiredContext } from "@redotech/react-util/context";
import { ConversionFeature } from "@redotech/redo-conversion-settings-common/checkout-optimization-settings";
import { useTranslation } from "@redotech/redo-i18n";
import SpotlightIcon from "@redotech/redo-icons/cursor-box.svg";
import SpotlightFilledIcon from "@redotech/redo-icons/cursor-box_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { memo } from "react";
import { LockableSecondaryNavItem } from "./lockable-secondary-nav-item";

export const PopupsItems = memo(function PopupsItems() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <LockableSecondaryNavItem
      buttonLocation={ScheduleDemoButtonLocation.NAV_SPOTLIGHTS}
      feature={ConversionFeature.SPOTLIGHTS}
      FilledIcon={SpotlightFilledIcon}
      friendlyName={t("Popups", {
        context:
          "checkout conversion navigation label for storefront popup offers",
      })}
      href={routes.popupsHref}
      id="popups"
      UnfilledIcon={SpotlightIcon}
    />
  );
});
